import React from "react";

const StepContent3 = ({ previousData, onNext }) => {
  const [city, setCity] = React.useState("");

  const handleNext = () => {
    onNext({
      ...previousData,
      city
    });
  };

  const name = previousData && previousData.name ? previousData.name : "—";
  const age = previousData && previousData.age ? previousData.age : "—";

  return React.createElement(
    "div",
    { className: "step-content" },
    React.createElement("h2", null, "Шаг 3: Город"),
    React.createElement(
      "p",
      null,
      "Имя: ",
      React.createElement("strong", null, name),
      ", возраст: ",
      React.createElement("strong", null, age)
    ),
    React.createElement("input", {
      className: "step-input",
      type: "text",
      placeholder: "Ваш город",
      value: city,
      onChange: (e) => setCity(e.target.value)
    }),
    React.createElement(
      "button",
      {
        className: "step-button",
        onClick: handleNext,
        disabled: !city
      },
      "Далее"
    )
  );
};

export default StepContent3;


